"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeriesStartDateProperty = exports.seriesStartDatePropertyDefinition = void 0;
exports.seriesStartDatePropertyDefinition = {
    view: { label: 'Series start date' },
    constraints: [],
    type: 'date',
    multiple: false,
    name: 'series-start-date',
};
const isSeriesStartDateProperty = (prop) => {
    return prop.name === exports.seriesStartDatePropertyDefinition.name;
};
exports.isSeriesStartDateProperty = isSeriesStartDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VyaWVzLXN0YXJ0LWRhdGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9zZXJpZXMtc3RhcnQtZGF0ZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxtQkFBbUIsRUFBRTtJQUNwQyxXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsbUJBQW1CO0NBQ00sQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9